export const CommonStatus = Object.freeze({
  Approved: 1,
  Pending: 2,
  Rejected: 3,
  Archived: 4,
 
  1: "Approved",
  2: "Pending",
  3: "Rejected",
  4: "Archived",
 
});
 
 
//used for set the flag of blog submission like submit as draft or direct post
export const blogPostStatus = Object.freeze({
     submit : 5,
     draft : 6,
 
     5 : "submit",
     6 : "draft"
 
});
 
export const blogVisibilityStatus = Object.freeze({
     enable : 1,
     disable : 0,
 
     1 : "enable",
     0 : "disable"
 
});

export const contentCategoryId = Object.freeze({
     blog  : 1,
     article : 2,
     newsLetter : 3,
 
     1 : "blog",
     2 : "article",
     3 : "newsLetter" 
 
});



